import { AxiosResponse } from 'axios';

import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from '../../http';
import {
  IGetProfilesResponse,
  ICreateProfileResponse,
  IUpdateProfileResponse,
  IDeleteProfilesResponse,
  ICreateProfileRequest,
  IDeleteProfilesFilters,
  IUpdateProfileRequest,
  IGetProfileByIdResponse,
} from 'models/http/profile';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { IGetSimpleListFilters, IGetSimpleListResponse, ISearchWithPaginationFilter } from 'models/http/common';
import { HTTP } from './core.http';
import DataUploadBaseHttp from './utils/data-upload.http';
import { DataUploadModels, ModelsNames } from 'utils/enums/model-names';

class ProfileHttp extends DataUploadBaseHttp implements HTTP<IDeleteProfilesFilters> {
  public static DataExportRoute = `${ModelsNames.Profiles}/data-export`;
  protected readonly route: DataUploadModels = ModelsNames.Profiles;

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`/${this.route}/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async get(filters?: ISearchWithPaginationFilter, abortController?: AbortController): Promise<IGetProfilesResponse> {
    const queryParams = prepareQPFromFilters(filters || {});

    return serverAxios
      .get(`/${this.route}/${queryParams.toString()}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetProfilesResponse>) => response.data);
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetProfileByIdResponse> {
    return serverAxios
      .get(`/${this.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetProfileByIdResponse>) => response.data);
  }

  public async create(profile: ICreateProfileRequest): Promise<ICreateProfileResponse> {
    return serverAxios
      .post(`/${this.route}`, profile, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateProfileResponse>) => response.data);
  }

  public async update(id: number, profile: IUpdateProfileRequest): Promise<IUpdateProfileResponse> {
    return serverAxios
      .put(`/${this.route}/${id}`, profile)
      .then((response: AxiosResponse<IUpdateProfileResponse>) => response.data);
  }

  public async delete(ids: number[]): Promise<IDeleteProfilesResponse>;
  public async delete(filters: IDeleteProfilesFilters): Promise<IDeleteProfilesResponse>;
  public async delete(filters: number[] | IDeleteProfilesFilters): Promise<IDeleteProfilesResponse> {
    return serverAxios
      .delete(`/${this.route}`, {
        data: prepareFiltersOfSelection(filters),
        timeout: HttpTimeoutPriority.Low,
      })
      .then((response: AxiosResponse<IDeleteProfilesResponse>) => {
        return response.data;
      });
  }
}

export default ProfileHttp;
